/** A tab open for days must not keep everything it ever saw. */
const MAX_REMEMBERED = 2_000;

/** Drops the oldest entry when full; insertion order is age. */
export function makeRoom<T>(
  seen: Set<T> | Map<T, unknown>,
  limit: number = MAX_REMEMBERED,
) {
  if (seen.size < limit) return;
  const oldest = seen.keys().next();
  if (!oldest.done) seen.delete(oldest.value);
}
